import config from '../config';

export const getAdminUrl = (locationId?: number) => (locationId ? getLocationAdminUrl(locationId) : getUrl());

const getUrl = () => {
  return config.env === 'prod' ? 'https://admin.favrit.com/' : 'https://admin.qa.favrit.com/';
};

export const getLocationAdminUrl = (locationId: number) => {
  return `${getUrl()}#/location/${locationId}`;
};

export const getOrderHistoryUrl = (locationId: number) => {
  return `${getUrl()}#/location/${locationId}/order-history`;
};
